module.exports = __webpack_public_path__ + "static/img/09_抗菌コーティング.b1282e9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/09_抗菌コーティング.png
// module id = +lGe
// module chunks = 0